import { RefObject, useEffect } from "react";

const useScrollShadow = (ref: RefObject<HTMLElement>, classNames: string = "border-t border-lightGray dark:border-darkMediumGray") => {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const classList = classNames.split(" ").filter(Boolean);

    const onScroll = () => {
      if (element.scrollTop > 0) {
        element.classList.add(...classList);
      } else {
        element.classList.remove(...classList);
      }
    };

    onScroll();

    element.addEventListener("scroll", onScroll);
    return () => element.removeEventListener("scroll", onScroll);
  }, [ref, classNames]);
};

export default useScrollShadow;
